import React, { useEffect, useState } from "react";
import axios from "../../api/axiosAuth";
import "../../style/PadreAsistencia.css";

const PadreAsistencia = () => {
  const [hijos, setHijos] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ================= HIJOS ================= */
  useEffect(() => {
    const load = async () => {
      const res = await axios.get("/padre/mis-hijos");
      setHijos(res.data || []);
    };
    load();
  }, []);

  /* ================= ASISTENCIA ================= */
  useEffect(() => {
    if (!selectedId) return;

    const load = async () => {
      setLoading(true);
      const res = await axios.get(`/padre/asistencia/${selectedId}`);
      setData(res.data);
      setLoading(false);
    };

    load();
  }, [selectedId]);

  const getDia = (fecha) =>
    new Date(fecha).toLocaleDateString("es-CO", { weekday: "long" });

  const getFecha = (fecha) =>
    new Date(fecha).toLocaleDateString("es-CO");

  const color = (estado) => {
    switch ((estado || "").toLowerCase()) {
      case "presente":
        return "green";
      case "ausente":
        return "red";
      case "tardanza":
        return "orange";
      default:
        return "#333";
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📅 Asistencia del Estudiante</h2>

      <select onChange={(e) => setSelectedId(e.target.value)}>
        <option value="">Seleccione hijo</option>
        {hijos.map((h) => (
          <option key={h.estudiante_id} value={h.estudiante_id}>
            {h.nombres_estudiante} {h.apellidos_estudiante}
          </option>
        ))}
      </select>

      {loading && <p>⏳ Cargando...</p>}

      {data && (
        <>
          {/* RESUMEN */}
          <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
            <div>✅ {data.resumen.presentes}</div>
            <div>❌ {data.resumen.ausentes}</div>
            <div>⏰ {data.resumen.tardanzas}</div>
          </div>

          {/* TABLA */}
          <table style={{ width: "100%", marginTop: 20 }}>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Día</th>
                {/* <th>Materia</th>
                <th>Horario</th> */}
                {/* <th>Estado</th> */}
              </tr>
            </thead>

            <tbody>
              {data.registros.map((r, i) => (
                <tr key={i}>
                  <td>{getFecha(r.fecha)}</td>
                  <td>{getDia(r.fecha)}</td>
                  {/* <td>{r.materia || "—"}</td> */}
                  <td>
                    {/* {r.hora_inicio || "—"} - {r.hora_fin || "—"} */}
                  </td>
                  <td style={{ color: color(r.estado) }}>
                    {r.estado}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default PadreAsistencia;
